import React from 'react';
import ColorsMain from '../../colors/ColorsMain'; // Solo si necesitas usar la variable de color


const CardWalletBalance = ({
  balance = "$3,000,000.32",
  label = "Balance total",
  colorlabel = "white",
  loading = false, // Nueva prop para controlar el skeleton
}) => {
  return (
    <div
      className="w-full h-full flex flex-col py-8 px-6 bg-[#1a1b22] justify-center rounded-xl gap-1"
      style={{ '--bg-layout': ColorsMain?.bgLayout }}
    >
      {loading ? (
        // Modo Skeleton
        <>
          {/* Skeleton para el label */}
          <div className="h-4 w-24 bg-gray-700 rounded animate-pulse"></div>
          {/* Skeleton para el balance */}
          <div className="h-6 w-32 bg-gray-700 rounded animate-pulse"></div>
        </>
      ) : (
        // Datos reales
        <>
          <p style={{ color: colorlabel }}>{label}</p>
          <h2 className="text-white text-[28px]">{balance}</h2>
        </>
      )}
    </div>
  );
};

export default CardWalletBalance;
